import { createFileRoute } from '@tanstack/react-router'

const DEFAULT_RANGE_ID = 'soderhamn'

// Maybe irrelevent now since there is no easy way to use the navigator gallery to navigate to the planner.
export const Route = createFileRoute('/$country/$language/planner/')({
  beforeLoad: async () => {
    throw Route.redirect({
      to: '/$country/$language/planner/$rangeId',
      params: { rangeId: DEFAULT_RANGE_ID },
    })
  },
})
